import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function CircularIndeterminate({ label = "Loading..." }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: 2,
        alignItems: "center",
      }}
    >
      <CircularProgress />
      <Typography variant="h6">{label}</Typography>
    </Box>
  );
}
